import * as THREE from 'three';
import { ping } from './audio';
import { _tmp } from './beam';
import { addSurge } from './combo';
import { GEM_N, buildings, gems } from './entities';
import { toast } from './hud';
import { minimap } from './minimap';
import { sparks } from './particles';
import { rig, scene } from './scene';
import { BB, S } from './state';
import { rnd } from './util';

export const gemGeo = new THREE.OctahedronGeometry(3.2, 0); export const gemMat = new THREE.MeshStandardMaterial({color:'#f5b642', emissive:new THREE.Color(2.6,1.5,0.3), emissiveIntensity:1, roughness:.2, metalness:.3});
export const gemColGeo = new THREE.CylinderGeometry(1.2, 2.2, 140, 8, 1, true); export const gemColMat = new THREE.MeshBasicMaterial({color:new THREE.Color(2,1.3,0.35), transparent:true, opacity:.16, blending:THREE.AdditiveBlending, depthWrite:false, side:THREE.DoubleSide, fog:false});
export function gemSpot(){
  for (let tries=0; tries<40; tries++){
    const x = rnd(-BB.half*0.9, BB.half*0.9), z = rnd(-BB.half*0.9, BB.half*0.9);
    let ok = true; for (const b of buildings){ const u = b.userData; if (Math.hypot(u.center.x-x, u.center.z-z) < u.fr + 6){ ok = false; break; } }
    if (ok) return new THREE.Vector3(x, 0, z);
  }
  return null;
}
export const gemHooks: { pickup: null | ((gm: any) => void) } = { pickup: null };
export function spawnGem(at?, id?){
  const p = at || gemSpot(); if (!p) return;
  const g = new THREE.Group(); const m = new THREE.Mesh(gemGeo, gemMat); m.position.y = 6; m.castShadow = true; g.add(m);
  const col = new THREE.Mesh(gemColGeo, gemColMat); col.position.y = 70; g.add(col);
  g.position.copy(p); g.position.y = groundAt(p.x, p.z, 0); scene.add(g); gems.push({g, m, col, id, born:performance.now()} as any); minimap.dirty = true;
}
export function clearGems(){ for (const gm of gems) scene.remove(gm.g); gems.length = 0; }
export function seedGems(){ clearGems(); for (let i=0;i<GEM_N;i++) spawnGem(); }
export function collectGem(gm, grant = true){
  const i = gems.indexOf(gm); if (i < 0) return; scene.remove(gm.g); gems.splice(i,1); minimap.dirty = true;
  if (!grant) return;
  const gain = 30; S.juice = Math.min(100, S.juice + gain); S.dry = false; addSurge(6);
  toast('+'+gain+' juice'); ping();
  for (let k=0;k<40;k++) sparks.emit(_tmp.copy(gm.g.position).setY(6), new THREE.Vector3(0,10,0), 24, 0.8);
}
export function updateGems(dt, now){
  const px = rig.base.x, pz = rig.base.z;
  for (let i=gems.length-1;i>=0;i--){
    const gm = gems[i]; gm.m.rotation.y += dt*1.6; gm.m.position.y = 6 + Math.sin(now/400 + i)*1.2; gm.col.material.opacity = 0.12 + 0.06*Math.sin(now/300+i);
    if (Math.hypot(gm.g.position.x-px, gm.g.position.z-pz) < 20){
      if (gemHooks.pickup){ if (!gm.pending){ gm.pending = true; gemHooks.pickup(gm); } continue; }   // World mode: the server confirms pickups
      collectGem(gm, true);
      setTimeout(() => { if (S.phase==='play') spawnGem(); }, 18000);
    }
  }
}
import { groundAt } from '../world/tiles';
